// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".transaction-confirm-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n.transaction-confirm-table td, .transaction-confirm-table th {\n  border: 1px solid #CFD8DC;\n  color: black;\n}\n.transaction-confirm-table td {\n  text-align: right;\n}", ""]);
// Exports
module.exports = exports;
